export default "__VITE_ASSET__BVV2El0l__"